import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import Loader from '@/components/Includes/Loader/Loader.vue';
import CampaignForm from '@/components/Subscriptions/Campaign/CampaignForm/CampaignForm.vue';
import ICampaign from '@/interfaces/subscriptions/ICampaign';
import {Component, Vue} from 'vue-property-decorator';
import {Action} from 'vuex-class';

const PROD_API_HOST = process.env.VUE_APP_API_HOST === 'https://api.cp-appadmin.com';

const initData = {
    clientAppId: 3,
    title: '',
    trafficSource: '',
    trackerId: '',
    outerCampaignId: 0,
    installPostbackUrl: 'http://swtchry.com/click.php?cnv_id={click_id}&payout=1.5',
    installPostbackUrlEnabled: false,
    trialPostbackUrl: 'http://swtchry.com/click.php?cnv_id={click_id}&payout=1.5',
    trialPostbackUrlEnabled: false,
    subscriptionPostbackUrl: 'http://swtchry.com/click.php?cnv_id={click_id}&payout=1.5',
    subscriptionPostbackUrlEnabled: false,
    isActive: true,
};

@Component({
    name: 'CampaignCreate',
    components: {
        Loader,
        CardHeader,
        CampaignForm
    }
})
export default class CampaignCreate extends Vue {
    @Action private subscriptionsCreateCampaign!: (payload: { createOnly: boolean, campaignData: ICampaign }) => string;

    private formData = initData;

    private async campaignCreate(payload: { createOnly: boolean, campaignData: ICampaign }) {
        try {
            await this.subscriptionsCreateCampaign(payload);
        } catch (error) {
            throw new Error(error)
        }
    }
};
